module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tcc-plan__wrapper"
  }, [_c('div', {
    staticClass: "tcc-plan__wrapper--contents"
  }, [_c('div', {
    staticClass: "tcc-plan__wrapper--title",
    domProps: {
      "innerHTML": _vm._s(_vm.heading)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tcc-plan__wrapper--subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.subtitle)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tcc-plan__wrapper--container"
  }, [(_vm.plans && _vm.plans.length) ? [_c('tabs', {
    on: {
      "tab-selected": function($event) {
        return _vm.tabSelected($event)
      }
    }
  }, _vm._l((_vm.plans), function(plan, index) {
    return (plan.variations && plan.variations.length) ? _c('tab', {
      key: index,
      attrs: {
        "hash": false,
        "name": plan.name,
        "selected": _vm.planSelected(plan),
        "alias": plan.name
      }
    }, [_c('div', {
      staticClass: "tcc-plan__box"
    }, [_c('div', {
      staticClass: "tcc-plan__box--details"
    }, [(_vm.planTemporaryPrice(plan)) ? _c('p', {
      staticClass: "tcc-plan__box--details__starting-at"
    }, [_vm._v("Starting at")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "tcc-plan__box--details__price"
    }, [(_vm.planPrice(plan)) ? [_c('span', [_vm._v("£")]), _vm._v(_vm._s(_vm.planPrice(plan))), (_vm.vatDisplay) ? _c('sup', [_vm._v(" + VAT")]) : _vm._e(), _vm._v(" / month\n                    "), _c('div', {
      staticClass: "tcc-plan__box--details__price--payment-period",
      domProps: {
        "innerHTML": _vm._s(_vm.planPaymentPeriod(plan))
      }
    })] : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "tcc-plan__box--details__options"
    }, [(!_vm.preSelectedSize) ? _c('div', {
      staticClass: "tcc-plan__box--details__option",
      class: [{
        'active': _vm.sizeSelectorActive
      }]
    }, [_c('label', {
      staticClass: "tcc-plan__box--details__option--label dynamic-option",
      attrs: {
        "for": "sizeOptions"
      }
    }, [_vm._v("Select organisation size")]), _vm._v(" "), _c('div', {
      staticClass: "tcc-plan__box--details__option--value"
    }, [_c('app-select', {
      staticClass: "tcc-plan__box--details__option--selector",
      attrs: {
        "customType": "planSelector",
        "searchable": false,
        "customActive": false,
        "clearable": false,
        "placeholder": 'Confirm number of employees',
        "options": plan.sizeOptions || [],
        "value": plan.selectedPlanSize,
        "data-vv-name": "Size",
        "data-lpignore": "true",
        "name": "sizeOptions",
        "id": "sizeOptions"
      },
      on: {
        "change": function($event) {
          return _vm.planSizeChanged($event, plan)
        }
      }
    })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "tcc-plan__box--details__option",
      class: [{
        'active': _vm.billingSelectorActive,
        'disabled': !plan.selectedPlanSize
      }]
    }, [_c('label', {
      staticClass: "tcc-plan__box--details__option--label dynamic-option",
      attrs: {
        "for": "billingOptions"
      }
    }, [_vm._v("Select billing cycle")]), _vm._v(" "), _c('div', {
      staticClass: "tcc-plan__box--details__option--value"
    }, [_c('app-select', {
      staticClass: "tcc-plan__box--details__option--selector",
      attrs: {
        "customType": "planSelector",
        "searchable": false,
        "customActive": false,
        "clearable": false,
        "placeholder": !plan.selectedPlanSize ? 'Select organisation size first' : 'Choose an option',
        "disabled": !plan.selectedPlanSize,
        "options": plan.billingOptions || [],
        "value": plan.selectedPlanBilling,
        "data-vv-name": "Billing",
        "data-lpignore": "true",
        "name": "billingOptions",
        "id": "billingOptions"
      },
      on: {
        "search:focus": function($event) {
          return _vm.searchFocus(plan, 'billing')
        },
        "search:blur": function($event) {
          return _vm.searchBlur(plan, 'billing')
        },
        "change": function($event) {
          return _vm.planBillingChanged($event, plan)
        }
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "tcc-plan__box--details__option",
      class: [{
        'active': _vm.commitmentSelectorActive,
        'disabled': !plan.selectedPlanSize
      }]
    }, [_c('label', {
      staticClass: "tcc-plan__box--details__option--label dynamic-option",
      attrs: {
        "for": "commitmentOptions"
      }
    }, [_vm._v("Select commitment period")]), _vm._v(" "), _c('div', {
      staticClass: "tcc-plan__box--details__option--value"
    }, [_c('app-select', {
      staticClass: "tcc-plan__box--details__option--selector",
      attrs: {
        "customType": "planSelector",
        "searchable": false,
        "customActive": false,
        "clearable": false,
        "placeholder": !plan.selectedPlanSize ? 'Select organisation size first' : 'Choose an option',
        "disabled": !plan.selectedPlanSize,
        "options": plan.commitmentOptions || [],
        "value": plan.selectedPlanCommitment,
        "data-vv-name": "Commitment",
        "data-lpignore": "true",
        "name": "commitmentOptions",
        "id": "commitmentOptions"
      },
      on: {
        "search:focus": function($event) {
          return _vm.searchFocus(plan, 'commitment')
        },
        "search:blur": function($event) {
          return _vm.searchBlur(plan, 'commitment')
        },
        "change": function($event) {
          return _vm.planCommitmentChanged($event, plan)
        }
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "tcc-plan__box--details__actions hide-on-mobile"
    }, [_c('button', {
      class: [{
        submitting: _vm.submitting
      }],
      on: {
        "click": function($event) {
          return _vm.selectPlan()
        }
      }
    }, [_c('span', [_c('svg', {
      staticClass: "svg-inline--fa fa-check fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "check",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M480 128c0 8.188-3.125 16.38-9.375 22.62l-256 256C208.4 412.9 200.2 416 192 416s-16.38-3.125-22.62-9.375l-128-128C35.13 272.4 32 264.2 32 256c0-18.28 14.95-32 32-32c8.188 0 16.38 3.125 22.62 9.375L192 338.8l233.4-233.4C431.6 99.13 439.8 96 448 96C465.1 96 480 109.7 480 128z"
      }
    })])]), _vm._v("\n                    Choose this plan\n                  ")])])]), _vm._v(" "), _c('div', {
      staticClass: "tcc-plan__box--features",
      class: [{
        'voucher-shown': _vm.voucherAreaActive
      }]
    }, [_c('div', {
      staticClass: "tcc-plan__box--features__voucher",
      class: [{
        'active': _vm.voucherAreaActive,
        'transition-in': _vm.voucherAreaTransitioning
      }],
      attrs: {
        "id": 'voucherContainer-' + index,
        "aria-expanded": (_vm.voucherAreaActive || _vm.voucherAreaTransitioning) || 'false'
      }
    }, [_c('button', {
      staticClass: "tcc-plan__box--features__voucher--trigger",
      class: [{
        'activate': !_vm.voucherAreaActive && !_vm.voucherAreaTransitioning,
        'deactivate': _vm.voucherAreaActive || _vm.voucherAreaTransitioning
      }],
      attrs: {
        "aria-label": !_vm.voucherAreaActive && !_vm.voucherAreaTransitioning ? 'Use a voucher' : 'Close voucher area',
        "aria-expanded": (_vm.voucherAreaActive || _vm.voucherAreaTransitioning) || 'false',
        "aria-controls": 'voucherContainer-' + index
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.activateVoucherArea()
        }
      }
    }, [(!_vm.voucherAreaActive && !_vm.voucherAreaTransitioning) ? [(_vm.voucher) ? [_vm._v("\n                        Voucher applied: " + _vm._s(_vm.voucher) + "\n                        "), _c('svg', {
      staticClass: "svg-inline--fa fa-pen",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "pen",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M497.9 74.16L437.8 14.06c-18.75-18.75-49.19-18.75-67.93 0l-56.53 56.55l127.1 128l56.56-56.55C516.7 123.3 516.7 92.91 497.9 74.16zM290.8 93.23l-259.7 259.7c-2.234 2.234-3.755 5.078-4.376 8.176l-26.34 131.7C-1.921 504 7.95 513.9 19.15 511.7l131.7-26.34c3.098-.6191 5.941-2.141 8.175-4.373l259.7-259.7L290.8 93.23z"
      }
    })])] : [_vm._v("\n                        Use a voucher\n                        "), _c('svg', {
      staticClass: "svg-inline--fa fa-circle-question",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "circle-question",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 464c-114.7 0-208-93.31-208-208S141.3 48 256 48s208 93.31 208 208S370.7 464 256 464zM256 336c-18 0-32 14-32 32s13.1 32 32 32c17.1 0 32-14 32-32S273.1 336 256 336zM289.1 128h-51.1C199 128 168 159 168 198c0 13 11 24 24 24s24-11 24-24C216 186 225.1 176 237.1 176h51.1C301.1 176 312 186 312 198c0 8-4 14.1-11 18.1L244 251C236 256 232 264 232 272V288c0 13 11 24 24 24S280 301 280 288V286l45.1-28c21-13 34-36 34-60C360 159 329 128 289.1 128z"
      }
    })])]] : [_c('svg', {
      staticClass: "svg-inline--fa fa-xmark",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "xmark",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 320 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M312.1 375c9.369 9.369 9.369 24.57 0 33.94s-24.57 9.369-33.94 0L160 289.9l-119 119c-9.369 9.369-24.57 9.369-33.94 0s-9.369-24.57 0-33.94L126.1 256L7.027 136.1c-9.369-9.369-9.369-24.57 0-33.94s24.57-9.369 33.94 0L160 222.1l119-119c9.369-9.369 24.57-9.369 33.94 0s9.369 24.57 0 33.94L193.9 256L312.1 375z"
      }
    })])]], 2), _vm._v(" "), (_vm.voucherAreaActive) ? _c('form', {
      staticClass: "tcc-plan__box--features__voucher--form",
      attrs: {
        "aria-label": 'voucher-' + index
      },
      on: {
        "submit": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.submitVoucher()
        }
      }
    }, [(!_vm.hideVoucherSubmitForm) ? [_c('div', {
      staticClass: "tcc-plan__box--features__voucher--title",
      attrs: {
        "id": 'voucher-' + index
      }
    }, [_vm._v("Do you have a voucher? Enter the code below.")]), _vm._v(" "), _c('div', {
      staticClass: "tcc-plan__box--features__voucher--form__group",
      class: [{
        'not-empty': !!_vm.voucher
      }]
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.voucher),
        expression: "voucher"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Type in here...",
        "name": "voucher"
      },
      domProps: {
        "value": (_vm.voucher)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.voucher = $event.target.value
        }
      }
    }), _vm._v(" "), _c('button', {
      attrs: {
        "type": "submit"
      }
    }, [_vm._v("Submit voucher")])])] : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "tcc-plan__box--features__voucher--form__status",
      class: [{
        'saved-voucher': _vm.hideVoucherSubmitForm
      }]
    }, [(_vm.voucherSubmitted) ? [(_vm.invalidVoucher) ? [_c('div', {
      staticClass: "tcc-plan__box--features__voucher--form__status--title"
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-circle-xmark",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "circle-xmark",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256C397.4 512 512 397.4 512 256S397.4 0 256 0zM336.1 303c9.375 9.375 9.375 24.56 0 33.94c-9.381 9.381-24.56 9.373-33.94 0L256 289.9l-47.03 47.03c-9.381 9.381-24.56 9.373-33.94 0c-9.375-9.375-9.375-24.56 0-33.94l47.03-47.03L175 208.1c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L256 222.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94l-47.03 47.03L336.1 303z"
      }
    })]), _vm._v("\n                            The code you entered is invalid.\n                          ")]), _vm._v(" "), _c('div', {
      staticClass: "tcc-plan__box--features__voucher--form__status--text"
    }, [_vm._v("\n                            Please try again. If it still doesn't work, please get in touch with the code provider and check if it's correct.\n                          ")])] : [_c('div', {
      staticClass: "tcc-plan__box--features__voucher--form__status--title"
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-circle-check",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "circle-check",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM371.8 211.8l-128 128C238.3 345.3 231.2 348 224 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L224 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C382.7 183.1 382.7 200.9 371.8 211.8z"
      }
    })]), _vm._v("\n                            The code you entered '" + _vm._s(_vm.voucher) + "' was successfully applied.\n                          ")]), _vm._v(" "), _c('div', {
      staticClass: "tcc-plan__box--features__voucher--form__status--text"
    })]] : (_vm.hideVoucherSubmitForm) ? [_c('div', {
      staticClass: "tcc-plan__box--features__voucher--form__status--saved__title"
    }, [_vm._v("\n                          You have applied a voucher code '" + _vm._s(_vm.voucher) + "'.\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "tcc-plan__box--features__voucher--form__status--saved__actions"
    }, [_c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.submitAnotherVoucher()
        }
      }
    }, [_vm._v("Submit another voucher code")]), _vm._v(" "), _c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteVoucher()
        }
      }
    }, [_vm._v("Delete voucher code")])])] : _vm._e()], 2)], 2) : _vm._e()]), _vm._v(" "), _c('h3', {
      staticClass: "tcc-plan__box--features__title"
    }, [_vm._v("Plans features at a glance")]), _vm._v(" "), _c('div', {
      staticClass: "tcc-plan__box--features__list",
      domProps: {
        "innerHTML": _vm._s(_vm.planDescription(plan))
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "tcc-plan__box--details__actions hide-on-desktop"
    }, [_c('button', {
      class: [{
        submitting: _vm.submitting
      }],
      on: {
        "click": function($event) {
          return _vm.selectPlan()
        }
      }
    }, [_c('span', [_c('svg', {
      staticClass: "svg-inline--fa fa-check fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "check",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M480 128c0 8.188-3.125 16.38-9.375 22.62l-256 256C208.4 412.9 200.2 416 192 416s-16.38-3.125-22.62-9.375l-128-128C35.13 272.4 32 264.2 32 256c0-18.28 14.95-32 32-32c8.188 0 16.38 3.125 22.62 9.375L192 338.8l233.4-233.4C431.6 99.13 439.8 96 448 96C465.1 96 480 109.7 480 128z"
      }
    })])]), _vm._v("\n                  Choose this plan\n                ")])])])]) : _vm._e()
  }), 1)] : [_vm._m(0)]], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-data"
  }, [_c('div'), _c('div'), _c('div')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5def156","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/subscriptions/plans/PlansList.vue
// module id = 1062
// module chunks = 0